import { Link, useParams } from "react-router-dom";
import { useApi } from "../lib/api";
import { useSeo } from "../lib/seo";
import { useStore } from "../context/StoreContext";
import { PageHero } from "../components/shop/Common";
import NotFoundBlock from "./NotFoundBlock";

export default function PolicyPage() {
  const { slug } = useParams();
  const { preview } = useStore();
  const { data: p, loading, error } = useApi(`/pages/${slug}`);
  useSeo({ title: p?.title, description: p ? `${p.title} for VacationApparel.com.` : undefined, noindex: p?.status !== "published" });
  if (error) return <NotFoundBlock />;
  if (loading) return <div className="h-72 bg-navy animate-pulse" />;
  const published = p.status === "published";
  return (
    <>
      <PageHero eyebrow="Policies" title={p.title} />
      <section className="max-w-3xl mx-auto px-4 sm:px-6 py-14" data-testid="policy-content">
        {!published && !preview ? (
          <div className="rounded-3xl bg-sand p-8 text-navy" data-testid="policy-pending">
            <p className="font-bold text-lg">This policy is being finalized.</p>
            <p className="mt-2 text-navy/70">Have a question in the meantime? <Link to="/contact" className="underline">Contact us</Link>.</p>
          </div>
        ) : (
          <>
            {!published && (
              <div className="mb-8 rounded-2xl border-2 border-sunset bg-sunset/10 p-4 text-sm text-navy" data-testid="policy-draft-banner">
                <b>DRAFT — awaiting owner review.</b> Visible only in preview mode. Not legal advice; please review before publishing.
              </div>
            )}
            <div className="space-y-8">
              {p.body.map(([h, t]) => (
                <div key={h}>
                  <h2 className="text-xl font-bold text-navy">{h}</h2>
                  <p className="mt-2 text-navy/75 leading-relaxed">{t}</p>
                </div>
              ))}
            </div>
          </>
        )}
      </section>
    </>
  );
}
